import httpClient from "../../httpClient";

let credentials = null;
let getCredentialsTask = null;

const apiUrl = process.env.REACT_APP_API_URL;

const getLoggingCredentials = async () => {
  if (getCredentialsTask) {
    await getCredentialsTask;
  }

  try {
    await getCredentials();
  } finally {
    getCredentialsTask = null;
  }

  return credentials;
};

const getCredentials = async () => {
  if (!isCredentialsExpired()) {
    return;
  }

  getCredentialsTask = fetchNewCredentials();

  try {
    await getCredentialsTask;
  } finally {
    getCredentialsTask = null;
  }
};

const fetchNewCredentials = async () => {
  const url = `${apiUrl}/get-credentials-for-logging`;

  const { data } = await httpClient.get(url);

  credentials = data;

  return data;
};

const isCredentialsExpired = () => {
  return !(
    credentials?.credentials?.expirationTs &&
    credentials.credentials.expirationTs - Date.now() > 5000
  );
};

const cloudWatchTokenProvider = {
  getLoggingCredentials,
  isCredentialsExpired
};

export default cloudWatchTokenProvider;
